import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'

/** request Beneficiaries List
@return { promise } - Operators request
*/

export const requestBeneficiariesList = async (context, payload) => {
    const res = await beneficiariesApi.requestBeneficiariesList(payload)
    if (res) context.commit('SAVE_BENEFICIARIES_LIST', res.data.data)
    return res
}

/** Delete Beneficiaries
@return {promise} - Delete Beneficiaries
*/
export const deleteBeneficiary = async (context, payload) => {
    const res = await beneficiariesApi.deleteBeneficiary(payload)

    return res
 }

/** Creates Beneficiary
@return { promise } - Create Beneficiary
*/
export const createBeneficiary = async (context, payload) => {
    const res = await beneficiariesApi.createBeneficiary(payload)

    return res
}

/** Edits Beneficiary
@return { promise } - Edit Beneficiary
 */

export const editBeneficiary = async (context, payload) => {
    const res = await beneficiariesApi.editBeneficiary(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
